import cn from 'classnames'
import dynamic from 'next/dynamic'
import React, { memo, useEffect } from 'react'
import { useSelector } from 'react-redux'
import Drawer from 'src/components/global/Drawer/Drawer'
// import { Section } from 'src/components/global/Overview/Section'
// import { ReviewsContainer } from 'src/components/ReviewsContainer/ReviewsContainer'
import { THEME } from 'src/config/config'
import { fundingAmountsC, fundingInfosC } from 'src/constants/constants'
import {
  IEnum_Solution_Type,
  IProductSolutionDataFragment,
  ISimilarSolutionItemFragment,
  useGetProductSolutionSecurityDataLazyQuery,
} from 'src/graphql/generated/hooks'
import { AppState } from 'src/store/types'
// import { CompareInfos } from 'src/store/types/compare'
import {
  /* CompareSolution,  */
  DETAILS_TAB,
  FeaturesType,
  REVIEWS_TAB,
  SectionItem,
  VENDOR_ANALYSIS_TAB,
} from 'src/types'
import { checkNotEmpty } from 'src/utils/checkNotEmpty'
import { getFeaturesItems } from 'src/utils/getFeaturesItems'
import { getYearFoundedItem } from 'src/utils/getYearFoundedItem'

import IconBusiness from '../../assets/icon_business.svg'
import IconLawFirms from '../../assets/icon_law_firms.svg'
import { ThemeOnly } from '../global/ThemeOnly'
import { RelatedContents } from '../Partials/RelatedContents/RelatedContents'
import SkeletonLoading from '../SkeletonLoading/SkeletonLoading'
// import { ArticleCart } from '../ArticleCart/ArticleCart'
// import { CompareModalContent } from '../CompareModalContent/CompareModalContent'
// import { SimilarSolutions } from '../SimilarSolutions/SimilarSolutions'
import { SolutionFounderItem } from '../SolutionFounderItem/SolutionFounderItem'
//import { SolutionFounderItemWithoutAvatar } from '../SolutionFounderItem/SolutionFounderItemWithoutAvatar'
import SolutionVendorAnalysisContainer from '../SolutionsPage/SolutionVendorAnalysisContainer/SolutionVendorAnalysisContainer'

export interface VendorDetailContainerProps {
  className?: string
  solution: IProductSolutionDataFragment
  tabIdx: number
  similars: ISimilarSolutionItemFragment[]
  slug: string
  relatedContent?: any[]
  totalRelatedContent?: number
}
export interface Article {
  image: {
    url: string
  }
  title: string
  publishedBy: string
  date: string
  link: string
}

const CompareModalContent = dynamic(
  () => import('../CompareModalContent/CompareModalContent').then((mod) => mod.CompareModalContent),
  {
    loading: () => <SkeletonLoading className="bg-navy" />,
  },
)
const Section = dynamic(() => import('src/components/global/Overview/Section').then((mod) => mod.Section), {
  loading: () => <SkeletonLoading className="bg-navy" />,
})
const ArticleCart = dynamic(() => import('../ArticleCart/ArticleCart').then((mod) => mod.ArticleCart), {
  loading: () => <SkeletonLoading className="bg-navy" />,
})
const SimilarSolutions = dynamic(
  () => import('../SimilarSolutions/SimilarSolutions').then((mod) => mod.SimilarSolutions),
  {
    loading: () => <SkeletonLoading className="bg-navy" />,
  },
)
const ReviewsContainer = dynamic(
  () => import('src/components/ReviewsContainer/ReviewsContainer').then((mod) => mod.ReviewsContainer),
  {
    loading: () => <SkeletonLoading className="bg-navy" />,
  },
)
/**
 * Primary UI component for user interaction
 */
export const VendorDetailContainer: React.FC<VendorDetailContainerProps> = memo(
  ({ className, solution, tabIdx, similars, slug, relatedContent = [], totalRelatedContent = 0 }) => {
    const isEnhanced = solution.attributes?.isEnhanced
    const longDescription = solution.attributes?.longDescription || ''
    const website = solution.attributes?.website || ''
    const languages = solution.attributes?.languages?.data || []
    const hqs = solution.attributes?.hqs?.data || []
    const offices = solution.attributes?.offices?.data || []
    const descOtherIntegration = solution.attributes?.descOtherIntegration || ''
    const regionsServed = solution.attributes?.regionsServed?.data || []
    const subTopics = solution.attributes?.subTopics?.data || []
    const yearFounded = solution.attributes?.yearFounded
    const audiences = solution.attributes?.productData?.audiences?.data || []
    const attributes = solution.attributes?.productData?.attributes?.data || []
    const founders = solution.attributes?.founders || []
    const features = solution.attributes?.features?.data || []
    const linkedin = solution.attributes?.linkedin || ''
    const twitter = solution.attributes?.twitter || ''
    const practiceAreas = solution.attributes?.productData?.practiceAreas?.data || []
    const valueProposition = solution.attributes?.productData?.valueProposition || ''
    const deployments = solution.attributes?.productData?.deployments?.data || []
    const integrations = solution.attributes?.productData?.integrations?.data || []
    const typeOfUser = solution.attributes?.productData?.typeOfUser?.data || []
    const fundingInfo = solution.attributes?.productData?.fundingInfo
    const fundingAmount = solution.attributes?.productData?.fundingAmount
    const [isVisible, setIsVisible] = React.useState(false)
    const closeDrawer = React.useCallback(() => setIsVisible(false), [])
    const [detailsItems, setDetailsItems] = React.useState<SectionItem[]>([])

    const [loadContents, { loading: securityLoading, data: securityData }] =
      useGetProductSolutionSecurityDataLazyQuery()
    const randomNum = Math.floor(Math.random() * 1000)

    const compareInfos = useSelector((state: AppState) => state.compareInfos || {})
    const authInfo = useSelector((state: AppState) => state.authInfo || {})

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [solutionData, setSolutionData] = React.useState<IProductSolutionDataFragment>(solution)

    /* const { compareInfos, authInfo } = useSelector((state: AppState) => ({
      compareInfos: state.compareInfos || {},
      authInfo: state.authInfo || {},
    })) */

    useEffect(() => {
      if (compareInfos?.solutions?.length > 0) {
        if (compareInfos.solutions.length === 1) {
          // const compare: CompareSolution = compareInfos.solutions[0]
          /* if (compare.slug !== solution.attributes?.slug) {
          setIsVisible(true)
        } else {
          setIsVisible(false)
        } */
          setIsVisible(true)
        } else {
          setIsVisible(true)
        }
      } else {
        setIsVisible(false)
      }
    }, [compareInfos])

    const overviewItems: SectionItem[] = []

    if (checkNotEmpty(hqs)) {
      const convertedItems: FeaturesType[] =
        hqs
          ?.filter((item) => !!item.attributes?.name)
          .map((item) => ({ name: item.attributes?.name || '', iconColor: '#011D58' })) || []

      const item: SectionItem = {
        title: 'HEADQUARTERS',
        type: 'SpanDataIcon',
        subType: 'normal',
        items: convertedItems,
      }
      overviewItems.push(item)
    }

    if (checkNotEmpty(linkedin)) {
      const item: SectionItem = { type: 'LinkedinIconLink', items: [linkedin!] }
      overviewItems.push(item)
    }

    if (checkNotEmpty(languages)) {
      const convertedItems: FeaturesType[] =
        languages?.filter((item) => !!item.attributes?.name).map((item) => ({ name: item.attributes?.name || '' })) ||
        []
      const item: SectionItem = { title: 'LANGUAGES', type: 'SpanDataList', subType: 'more', items: convertedItems }
      overviewItems.push(item)
    }
    if (checkNotEmpty(offices)) {
      const convertedItems: FeaturesType[] =
        offices?.filter((item) => !!item?.attributes?.name).map((item) => ({ name: item?.attributes?.name || '' })) ||
        []
      const item: SectionItem = { title: 'OFFICES', type: 'SpanDataList', subType: 'normal', items: convertedItems }
      overviewItems.push(item)
    }

    if (checkNotEmpty(twitter)) {
      const item: SectionItem = { type: 'TwitterIconLink', items: [twitter!] }
      overviewItems.push(item)
    }

    if (checkNotEmpty(yearFounded)) {
      const yearFoundedItem = getYearFoundedItem('YEAR FOUNDED', yearFounded)
      if (yearFoundedItem) {
        overviewItems.push(yearFoundedItem)
      }
    }
    if (checkNotEmpty(regionsServed)) {
      const convertedItems: FeaturesType[] =
        regionsServed
          ?.filter((item) => !!item.attributes?.name)
          .map((item) => ({ name: item.attributes?.name || '' })) || []
      const item: SectionItem = {
        title: 'REGIONS SERVED',
        type: 'SpanDataList',
        subType: 'normal',
        items: convertedItems,
      }
      overviewItems.push(item)
    }

    if (checkNotEmpty(fundingInfo)) {
      const item: SectionItem = {
        title: 'Latest Funding Round',
        type: 'DottedDataList',
        subType: 'more',
        items: [{ name: fundingInfosC.find((item: any) => item.value === fundingInfo)?.label }],
      }
      overviewItems.push(item)
    }

    if (checkNotEmpty(fundingAmount)) {
      const item: SectionItem = {
        title: 'Total Funding Amount',
        type: 'DottedDataList',
        subType: 'more',
        items: [{ name: fundingAmountsC.find((item: any) => item.value === fundingAmount)?.label }],
      }
      overviewItems.push(item)
    }

    const featuresItems: SectionItem[] = getFeaturesItems(subTopics, features).filter((obj) =>
      obj.items.some((item) => item.isChecked),
    )

    const areasItems: SectionItem[] = []
    if (checkNotEmpty(audiences)) {
      const convertedItems: FeaturesType[] =
        (audiences &&
          audiences?.map((item) => {
            const name = item?.attributes?.name || ''
            let icon = ''
            if (name === 'Law Firms') icon = IconLawFirms
            else if (name === 'Corporate Legal') icon = IconBusiness
            const converted: FeaturesType = { name: name, icon: icon }
            return converted
          })) ||
        []
      const item: SectionItem = {
        title: 'TARGET AUDIENCE',
        type: 'SpanDataList',
        subType: 'cart',
        items: convertedItems,
      }
      areasItems.push(item)
    }

    if (isEnhanced && checkNotEmpty(typeOfUser)) {
      const convertedItems: FeaturesType[] =
        typeOfUser.filter((item) => !!item.attributes?.name).map((item) => ({ name: item.attributes?.name || '' })) ||
        []
      const item: SectionItem = {
        title: 'TYPE OF USER',
        type: 'DottedDataList',
        subType: '',
        items: convertedItems,
        isFullWidth: true,
      }
      areasItems.push(item)
    }
    if (checkNotEmpty(practiceAreas)) {
      const convertedItems: FeaturesType[] =
        practiceAreas
          ?.filter((item) => !!item.attributes?.name)
          .map((item) => ({ name: item.attributes?.name || '' })) || []
      const item: SectionItem = {
        title: 'PRACTICE AREAS',
        type: 'DottedDataList',
        subType: '',
        items: convertedItems,
      }
      areasItems.push(item)
    }
    if (checkNotEmpty(valueProposition)) {
      const item: SectionItem = {
        title: 'Value Proposition',
        type: 'DottedDataList',
        subType: '',
        items: valueProposition ? [{ name: valueProposition }] : [],
        isFullWidth: true,
      }
      areasItems.push(item)
    }

    useEffect(() => {
      const _detailsItems: SectionItem[] = []
      if (checkNotEmpty(subTopics) && !detailsItems.some((item) => item.title === 'PRODUCT TYPES')) {
        const convertedItems: FeaturesType[] =
          subTopics?.filter((item) => !!item.attributes?.name).map((item) => ({ name: item.attributes?.name || '' })) ||
          []
        const item: SectionItem = {
          title: 'PRODUCT TYPES',
          type: 'SpanDataList',
          subType: 'cart',
          items: convertedItems,
          isFullWidth: true,
        }
        _detailsItems.push(item)
      }

      if (checkNotEmpty(founders) && !detailsItems.some((item) => item.title === 'Founders')) {
        const foundersItem: SectionItem = {
          title: 'Founders',
          type: 'CustomList',
          subType: '',
          isFullWidth: true,
          items: founders || [],
        }
        _detailsItems.push(foundersItem)
      }

      if (checkNotEmpty(attributes) && !detailsItems.some((item) => item.title === 'ATTRIBUTES')) {
        const convertedItems: FeaturesType[] =
          attributes
            ?.filter((item) => !!item.attributes?.name)
            .map((item) => ({ name: item.attributes?.name || '' })) || []
        const item: SectionItem = {
          title: 'ATTRIBUTES',
          type: 'DottedDataList',
          subType: '',
          items: convertedItems,
          isFullWidth: true,
          colValue: 2,
        }
        _detailsItems.push(item)
      }

      if (checkNotEmpty(deployments) && !detailsItems.some((item) => item.title === 'DEPLOYMENT')) {
        const convertedItems: FeaturesType[] =
          deployments
            ?.filter((item) => !!item.attributes?.name)
            .map((item) => ({ name: item.attributes?.name || '' })) || []
        const item: SectionItem = { title: 'DEPLOYMENT', type: 'DottedDataList', subType: '', items: convertedItems }
        _detailsItems.push(item)
      }

      if (checkNotEmpty(integrations) && !detailsItems.some((item) => item.title === 'INTEGRATIONS')) {
        const convertedItems: FeaturesType[] =
          integrations
            ?.filter((item) => !!item.attributes?.name)
            .map((item) => ({
              name: item.attributes?.name || '',
              ...(item.attributes?.name.toLowerCase() === 'others' && { name: descOtherIntegration }),
            })) || []
        const item: SectionItem = { title: 'INTEGRATIONS', type: 'DottedDataList', subType: '', items: convertedItems }
        _detailsItems.push(item)
      }

      // if (_detailsItems.length > 0) {
      //   if (detailsItems.length > 0) {
      //     setDetailsItems(detailsItems.concat(_detailsItems))
      //   } else {
      //     setDetailsItems(_detailsItems)
      //   }

      // }
      // }, [solution, solutionData, slug, integrations])

      // useEffect(() => {
      //const _detailsItems: SectionItem[] = []

      const _securityData = securityData?.solutions?.data[0]?.attributes?.productData?.security?.data
      if (
        _securityData !== null &&
        _securityData !== undefined &&
        _securityData?.length > 0 &&
        !detailsItems.some((item) => item.title === 'Security')
      ) {
        if (_securityData?.length > 0) {
          const convertedItems: FeaturesType[] =
            _securityData
              ?.filter((item) => !!item.attributes?.name)
              .map((item) => ({ name: item.attributes?.name || '' })) || []
          const item: SectionItem = { title: 'Security', type: 'DottedDataList', subType: '', items: convertedItems }
          _detailsItems.push(item)
        } else {
          _detailsItems.push({
            title: 'Security',
            type: 'SpanDataList',
            subType: 'cart',
            items: [{ name: 'Security' }],
          })
        }
      }

      const _hostingLocationsData =
        securityData?.solutions?.data[0]?.attributes?.productData?.dataHostingLocations?.data
      if (
        _hostingLocationsData !== null &&
        _hostingLocationsData !== undefined &&
        _hostingLocationsData?.length > 0 &&
        !detailsItems.some((item) => item.title === 'Data Hosting Locations')
      ) {
        if (_hostingLocationsData?.length > 0) {
          const convertedItems: FeaturesType[] =
            _hostingLocationsData
              ?.filter((item) => !!item.attributes?.name)
              .map((item) => ({ name: item.attributes?.name || '' })) || []
          const item: SectionItem = {
            title: 'Data Hosting Locations',
            type: 'DottedDataList',
            subType: '',
            items: convertedItems,
          }
          _detailsItems.push(item)
        } else {
          _detailsItems.push({
            title: 'Data Hosting Locations',
            type: 'SpanDataList',
            subType: 'cart',
            items: [{ name: 'Data Hosting Locations' }],
          })
        }
      }

      if (_detailsItems.length > 0) {
        if (detailsItems.length > 0) {
          setDetailsItems(detailsItems.concat(_detailsItems))
        } else {
          setDetailsItems(_detailsItems)
        }
        // setDetailsItems(detailsItems.concat(_detailsItems))
      }
    }, [solution, solutionData, slug, securityLoading, securityData])

    useEffect(() => {
      if (THEME !== 'ilta') {
        loadContents({
          variables: {
            slug: slug,
          },
        })
      }
    }, [authInfo])

    return (
      <div className={cn(className, 'flex flex-col justify-center w-full px-5')}>
        {compareInfos?.solutions && compareInfos?.solutions?.length ? (
          <Drawer duration={250} hideScrollbars={true} onClose={closeDrawer} isVisible={isVisible}>
            <CompareModalContent onClose={closeDrawer} solutionType={compareInfos.solutions[0].solutionType} />
          </Drawer>
        ) : null}
        {tabIdx === DETAILS_TAB && (
          <div className="flex flex-col justify-center w-full">
            <div className="pl-[1.25rem] pr-[1.25rem] !max-w-[1100px] w-full flex md:flex-row flex-col py-2">
              <div
                className={`flex flex-col ${similars.length > 0 || relatedContent?.length > 0 ? 'md:w-[50rem] md:mr-[2.3125rem]' : 'w-full'} w-full`}
              >
                <Section
                  key={randomNum + '-Overview-Section'}
                  title={'Overview'}
                  description={longDescription || ''}
                  url={website || ''}
                  items={overviewItems}
                />
                {featuresItems.length > 0 && (
                  <Section
                    key={randomNum + '-Overview-Features'}
                    title={'Features'}
                    description={''}
                    url={''}
                    items={featuresItems}
                  />
                )}
                {areasItems.length > 0 && (
                  <Section
                    key={randomNum + '-Overview-AreasofUse'}
                    title={'Areas of Use'}
                    description={''}
                    url={''}
                    items={areasItems}
                  />
                )}
                {detailsItems.length > 0 && (
                  <Section
                    key={randomNum + '-Overview-Details'}
                    title={'Details'}
                    description={''}
                    url={''}
                    items={detailsItems}
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    renderItem={(founder: any) => <SolutionFounderItem founder={founder} />}
                  />
                )}
                {checkNotEmpty(solution.attributes?.articles) && (
                  <ArticleCart
                    key={randomNum + '-Overview-ArticleCart'}
                    articles={solution.attributes?.articles || []}
                  />
                )}
              </div>

              {(similars.length > 0 || relatedContent?.length > 0) && (
                <div className="flex flex-col md:w-[15rem] w-full h-full mb-auto">
                  <ThemeOnly theme="legaltech">
                    {relatedContent && (
                      <RelatedContents
                        contents={relatedContent}
                        slug={slug ? 'vendors/' + slug : ''}
                        totalRelatedContent={totalRelatedContent}
                      />
                    )}
                  </ThemeOnly>

                  {similars.length > 0 && (
                    <SimilarSolutions
                      key={randomNum + '-Overview-SimilarSolutions'}
                      similars={similars}
                      slug={slug}
                      originName={solution.attributes?.displayName || ''}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        {tabIdx === REVIEWS_TAB && (
          <ReviewsContainer
            key={randomNum + '-Overview-ReviewsContainer'}
            reviews={solution.attributes?.reviews?.data || []}
            isShowSubmit={true}
            title={solution.attributes?.displayName || ''}
            solutionType={IEnum_Solution_Type.Product}
            id={solution.id || ''}
            isProgressing={false}
            isEnhanced={false}
          />
        )}
        {tabIdx === VENDOR_ANALYSIS_TAB && (
          <SolutionVendorAnalysisContainer
            key={randomNum + '-Overview-SolutionVendorAnalysisContainer'}
            solutionId={solution.id || ''}
          />
        )}
      </div>
    )
  },
)
